import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PackageSelectorCustomComponentDirective } from './package-selector-custom.component';

@Component({
  selector: 'sales-ui-package-name-cell',
  template: `
    <span class="va-dropdown-list-item__icon-title">
      <va-icon
        mat-list-avatar
        [iconName]="title"
        [iconUrl]="iconUrl"
        [diameter]="40"
        class="va-dropdown-list-item__icon"
      ></va-icon>
      <span class="va-dropdown-list-item__title-container">
        <span class="va-dropdown-list-item__title">
          {{ title }}
        </span>
      </span>
    </span>
  `,
  styles: [
    `
      .va-dropdown-list-item__icon-title {
        display: flex;
        width: 100%;
        justify-content: flex-start;
      }

      .va-dropdown-list-item__icon {
        margin-right: 16px;
      }

      .va-dropdown-list-item__title-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageNameCellComponent extends PackageSelectorCustomComponentDirective implements OnInit {
  iconUrl: string;
  title: string;

  ngOnInit(): void {
    this.iconUrl = this.element.package.icon;
    this.title = this.element.package.name;
  }
}
